document.addEventListener("DOMContentLoaded", () => {
  /** Navigation hover opacity **/
  const listItems = document.querySelectorAll('li.x-menu--level-2--link, li.x-menu--level-3--link');
  listItems.forEach(item => {
    item.addEventListener('mouseenter', () => {
      listItems.forEach(el => el.classList.add('opacity-25'));
      item.classList.remove('opacity-25');
    });
    item.addEventListener('mouseleave', () => {
      listItems.forEach(el => el.classList.remove('opacity-25'));
    });
  });

  /** Navigation image pairing **/
  const menuItems = document.querySelectorAll('[data-menu-hover]');
  const imagePairs = document.querySelectorAll('.layered-image-pair');
  const showDefaultImage = () => {
    imagePairs.forEach(pair => {
      const isDefault = pair.getAttribute('data-menu') === 'default';
      pair.classList.toggle('hidden', !isDefault);
    });
  };
  menuItems.forEach(item => {
    item.addEventListener('mouseenter', () => {
      const target = item.getAttribute('data-menu-hover').trim().toLowerCase();
      imagePairs.forEach(pair => {
        const pairKey = pair.getAttribute('data-menu').trim().toLowerCase();
        pair.classList.toggle('hidden', pairKey !== target);
      });
    });
    item.addEventListener('mouseleave', showDefaultImage);
  });
  showDefaultImage();


  /** Split product slider **/
  const imageSlider = document.getElementById("image-slider");
  const productSlider = document.getElementById("product-slider");
  const prevBtn = document.getElementById("prevBtn");
  const nextBtn = document.getElementById("nextBtn");
  if (imageSlider && productSlider && prevBtn && nextBtn) {
    const totalSlides = imageSlider.children.length;
    let activeSlide = 0;
    const updateSlides = () => {
      const offset = `-${activeSlide * 100}%`;
      imageSlider.style.transform = `translateX(${offset})`;
      productSlider.style.transform = `translateX(${offset})`;
    };
    prevBtn.addEventListener("click", () => {
      activeSlide = (activeSlide - 1 + totalSlides) % totalSlides;
      updateSlides();
    });
    nextBtn.addEventListener("click", () => {
      activeSlide = (activeSlide + 1) % totalSlides;
      updateSlides();
    });
    updateSlides();
  }

  /** Carousel dot navigation **/
  const carousel = document.getElementById('carousel');
  const dots = document.querySelectorAll('.carousel-dot');
  const blocks = carousel?.querySelectorAll('.carousel--block');
  if (carousel && dots.length && blocks.length) {
    function scrollToIndex(index) {
      const block = blocks[index];
      if (block) {
        carousel.scrollTo({ left: block.offsetLeft, behavior: 'smooth' });
        updateDots(index);
      }
    }
    function updateDots(activeIndex) {
      dots.forEach((dot, i) => {
        dot.classList.toggle('opacity-100', i === activeIndex);
        dot.classList.toggle('opacity-50', i !== activeIndex);
      });
    }
    dots.forEach(dot => {
      dot.addEventListener('click', () => {
        const index = parseInt(dot.getAttribute('data-index'), 10);
        scrollToIndex(index);
      });
    });
    let scrollTimeout;
    carousel.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        const scrollLeft = carousel.scrollLeft;
        const blockWidth = blocks[0].offsetWidth;
        const activeIndex = Math.round(scrollLeft / blockWidth);
        updateDots(activeIndex);
      }, 100);
    });
    window.addEventListener('load', () => scrollToIndex(0));
  }

/** Video hover autoplay/reset **/
/** Show first frame immediately + hover play (Safari-safe) */
document.querySelectorAll('[data-video-block]').forEach((block) => {
  const video = block.querySelector('[data-hover-video]');
  if (!video) return;

  // --- Prep attributes for mobile/Safari ---
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  video.playsInline = true;
  video.muted = true;                 // allow programmatic play
  video.preload = isSafari ? 'auto' : 'metadata';

  // --- If using lazy sources, promote them and load ---
  const lazySources = video.querySelectorAll('source[data-src]');
  if (lazySources.length) {
    lazySources.forEach((s) => {
      s.setAttribute('src', s.getAttribute('data-src'));
      s.removeAttribute('data-src');
    });
    try { video.load(); } catch (_) {}
  }

  // --- Paint first frame (Safari needs a play→pause kick) ---
  async function paintFirstFrame() {
    // If no pixels yet, wait for them
    if (video.readyState < 2) {
      await new Promise((res) => {
        const on = () => { cleanup(); res(); };
        const cleanup = () => {
          video.removeEventListener('loadeddata', on);
          video.removeEventListener('loadedmetadata', on);
        };
        video.addEventListener('loadeddata', on, { once: true });
        video.addEventListener('loadedmetadata', on, { once: true });
      });
    }

    // Seek a hair off zero triggers decode on Safari
    try { video.currentTime = 0.001; } catch (_) {}

    // Kick a frame: play → next frame callback → pause
    try {
      const playP = video.play();
      if (playP && typeof playP.then === 'function') {
        await playP.catch(() => {});
      }
    } catch (_) {}

    // Pause as soon as a frame is actually painted
    if ('requestVideoFrameCallback' in HTMLVideoElement.prototype) {
      await new Promise((res) => video.requestVideoFrameCallback(() => res()));
      video.pause();
    } else {
      // Fallback: a tick is usually enough
      setTimeout(() => video.pause(), 30);
    }
  }

  // Run once now
  paintFirstFrame();

  // Hover behavior
  block.addEventListener('mouseenter', () => {
    video.muted = true; // belt-and-suspenders
    video.play().catch(() => {});
  });

  block.addEventListener('mouseleave', () => {
    video.pause();
    // Snap back to first frame for a clean poster-like look
    try { video.currentTime = 0.001; } catch (_) {}
  });
});

/**
 * Mobile-only autoplay for ALL ingredient videos, including late-added ones.
 * Targets <video class="ingredient-v"> and <video data-hover-video>.
 */
(function () {
  var SELECTOR = 'video.ingredient-v, video[data-hover-video]';

  var observers = new WeakMap();
  var enhanced  = new WeakSet();

  var mqlCoarse = window.matchMedia('(hover: none) and (pointer: coarse)');
  var mqlHover  = window.matchMedia('(hover: hover)');
  function isMobile() {
    return mqlCoarse.matches || (!mqlHover.matches && window.innerWidth <= 1024);
  }

  function setupMobile(v) {
    if (enhanced.has(v)) return;
    enhanced.add(v);

    // iOS/WebKit requirements for autoplay
    v.muted = true; v.setAttribute('muted', '');
    v.playsInline = true; v.setAttribute('playsinline', '');
    if (!v.getAttribute('preload')) v.setAttribute('preload', 'metadata');
    v.setAttribute('autoplay', '');

    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var e = entries[i];
        if (e.isIntersecting) {
          var p = v.play();
          if (p && p.catch) p.catch(function () { /* ignore */ });
        } else {
          v.pause();
        }
      }
    }, { threshold: 0.5 });
    io.observe(v);
    observers.set(v, io);
  }

  function teardownMobile(v) {
    var io = observers.get(v);
    if (io) { io.disconnect(); observers.delete(v); }
    v.removeAttribute('autoplay');
    try { v.pause(); v.currentTime = 0; } catch (_) {}
    enhanced.delete(v);
  }

  function applyToAll() {
    var list = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < list.length; i++) {
      var v = list[i];
      if (isMobile()) setupMobile(v);
      else teardownMobile(v);
    }
  }

  // Observe DOM for videos added later (sections, sliders, AJAX)
  var mo = new MutationObserver(function (mutations) {
    var changed = false;
    for (var m = 0; m < mutations.length; m++) {
      var rec = mutations[m];

      // Handle removed nodes (clean up)
      for (var r = 0; r < rec.removedNodes.length; r++) {
        var node = rec.removedNodes[r];
        if (node.querySelectorAll) {
          node.matches && node.matches(SELECTOR) && teardownMobile(node);
          var removedVids = node.querySelectorAll(SELECTOR);
          for (var k = 0; k < removedVids.length; k++) teardownMobile(removedVids[k]);
        }
      }

      // If any added node or its descendants contains videos, re-apply
      for (var a = 0; a < rec.addedNodes.length; a++) {
        var n = rec.addedNodes[a];
        if (n.nodeType !== 1) continue;
        if ((n.matches && n.matches(SELECTOR)) || (n.querySelector && n.querySelector(SELECTOR))) {
          changed = true;
          break;
        }
      }
      if (changed) break;
    }
    if (changed) applyToAll();
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // Shopify section lifecycle hooks
  document.addEventListener('shopify:section:load', applyToAll);
  document.addEventListener('shopify:section:unload', applyToAll);
  document.addEventListener('shopify:section:select', applyToAll);
  document.addEventListener('shopify:section:deselect', applyToAll);

  // Respond to environment changes
  function reapply() { applyToAll(); }
  if (mqlCoarse.addEventListener) {
    mqlCoarse.addEventListener('change', reapply);
    mqlHover.addEventListener('change', reapply);
  } else {
    mqlCoarse.addListener(reapply);
    mqlHover.addListener(reapply);
  }
  window.addEventListener('resize', reapply);
  window.addEventListener('orientationchange', reapply);

  // Initial bind
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyToAll);
  } else {
    applyToAll();
  }
})();

/** Ingredients modal toggle **/
window.openModal = () => {
    document.getElementById('ingredient-modal').classList.remove('hidden');
    document.getElementById('ingredient-modal').classList.add('flex');
  };
  window.closeModal = () => {
    document.getElementById('ingredient-modal').classList.add('hidden');
    document.getElementById('ingredient-modal').classList.remove('flex');
  };

  /** Ingredients hover switch **/
  const items = document.querySelectorAll(".ingredient-item");
  const images = document.querySelectorAll(".ingredient-hover-img");
  const texts = document.querySelectorAll(".ingredient-text-block");
  items.forEach((item) => {
    item.addEventListener("mouseenter", function () {
      const index = parseInt(this.getAttribute("data-index"));
      images.forEach((img, i) => img.classList.toggle("active", i === index));
      items.forEach((el, i) => {
        el.classList.toggle("text-black", i === index);
        el.classList.toggle("opacity-50", i !== index);
      });
      texts.forEach((text, i) => text.classList.toggle("hidden", i !== index));
    });
  });

  /** Stockist heading and pseudo click **/
  const insertStockistHeading = () => {
    const sidePanel = document.querySelector('.stockist-side-panel');
    const searchForm = document.querySelector('.stockist-search-form');
    if (!sidePanel || !searchForm) return;

    if (!sidePanel.querySelector('.desktop-heading')) {
      const desktopHeading = document.createElement('div');
      desktopHeading.className = 'stockist-heading desktop-heading';
      desktopHeading.innerHTML = `
        <h2 class="text-4xl text-left font-medium">Find a Hydrinity Professional near you</h2>
        <p class="text-m opacity-50 text-left">
          Enter your city or zip code to find an authorized Hydrinity Partner in your area.
        </p>`;
      sidePanel.prepend(desktopHeading);
    }

    if (!document.querySelector('.mobile-heading')) {
      const mobileHeading = document.createElement('div');
      mobileHeading.className = 'stockist-heading mobile-heading';
      mobileHeading.innerHTML = `
        <h2 class="text-4xl text-left font-medium">Find a Hydrinity Professional near you</h2>
        <p class="text-m opacity-50 text-left">
          Enter your city or zip code to find an authorized Hydrinity Partner in your area.
        </p>`;
      searchForm.parentNode.insertBefore(mobileHeading, searchForm);
    }

  document.querySelectorAll('.stockist-result-filter').forEach(el => {
    if (el.innerHTML.trim().toLowerCase() === 'gold') {
      el.classList.add('gold');
    }
  });
  };

  window.addEventListener('stockist:loaded', insertStockistHeading);
  setTimeout(insertStockistHeading, 3000); // backup trigger
});


/** slider-ingredients.liquid **/

document.addEventListener("DOMContentLoaded", function () {
  const slidesWrapper = document.querySelector('#ingredient-carousel');
  const navButtons = document.querySelectorAll('.ingredient-thumb');
  const label = document.getElementById('ingredient-label');
  const labelText = document.getElementById('ingredient-label-text');
  let activeSlide = 0;

  function goToSlide(index) {
    if (!slidesWrapper) return;
  
    document.querySelectorAll('.ingredient-slide').forEach((slide, i) => {
      slide.classList.toggle('active', i === index);
    });
  
    navButtons.forEach((btn, i) => {
      if (i === index) {
        btn.classList.add('ring-2', 'ring-gold');
        labelText.textContent = btn.getAttribute('data-title') || '';
        label.href = btn.getAttribute('data-url') || '#';
      } else {
        btn.classList.remove('ring-2', 'ring-gold');
      }
    });
  
    activeSlide = index;
  }

  navButtons.forEach((btn, index) => {
    btn.addEventListener('click', () => {
      goToSlide(index);
    });
  });

  goToSlide(0);
});

document.addEventListener("DOMContentLoaded", function () {
  const mobileSlides = document.querySelectorAll('.mobile-slide'); // includes both image & grid
  const navButtons = document.querySelectorAll('.ingredient-thumb-mobile');
  const label = document.getElementById('ingredient-label-mobile');
  const labelText = document.getElementById('ingredient-label-text-mobile');

  function goToSlide(index) {
    // Set visibility on ALL mobile slides (both image + grid)
    mobileSlides.forEach((slide) => {
      const i = parseInt(slide.getAttribute('data-index'), 10);
      const isActive = i === index;
      slide.classList.toggle('opacity-100', isActive);
      slide.classList.toggle('opacity-0', !isActive);
      slide.classList.toggle('pointer-events-none', !isActive);
    });

    // Update nav styling
    navButtons.forEach((btn, i) => {
      const isActive = i === index;
      btn.classList.toggle('ring-2', isActive);
      btn.classList.toggle('ring-gold', isActive);
      if (isActive) {
        labelText.textContent = btn.getAttribute('data-title') || '';
        label.href = btn.getAttribute('data-url') || '#';
      }
    });
  }

  navButtons.forEach((btn, index) => {
    btn.addEventListener('click', () => {
      goToSlide(index);
    });
  });

  goToSlide(0); // Init with first
});

/** blog.liquid (featured-article) **/

document.addEventListener('DOMContentLoaded', function () {
  const slider = document.getElementById('blog-featured-slider');
  if (!slider) return;

  const slides = slider.querySelector('.featured-slides');
  const slideTitles = [...slides.children].map(slide => slide.dataset.title); // Each slide must have data-title
  const articleNameEl = slider.querySelector('.slide-article-name');
  const progressBar = slider.querySelector('.slider-progress-bar');

  const totalSlides = slides.children.length;
  let currentIndex = 0;

  const updateSlider = () => {
    slides.style.transform = `translateX(-${currentIndex * 100}%)`;

    // Set next title or fallback to previous if at end
    const nextIndex = currentIndex + 1 < totalSlides ? currentIndex + 1 : currentIndex - 1;
    articleNameEl.textContent = slideTitles[nextIndex] || '';

    // Update progress bar
    const progress = ((currentIndex + 1) / totalSlides) * 100;
    progressBar.style.width = `${progress}%`;
  };

  slider.querySelector('.next').addEventListener('click', () => {
    currentIndex = (currentIndex + 1) % totalSlides;
    updateSlider();
  });

  slider.querySelector('.prev').addEventListener('click', () => {
    currentIndex = (currentIndex - 1 + totalSlides) % totalSlides;
    updateSlider();
  });

  updateSlider();
});

document.addEventListener('DOMContentLoaded', function () {
    const modal = document.getElementById('videoModal');
    const videoPlayer = document.getElementById('videoPlayer');
    const closeModalBtn = document.getElementById('closeModal');
    const openBtn = document.querySelector('.v-thumbnail-button');

    if (openBtn && modal && videoPlayer) {
      openBtn.addEventListener('click', function () {
        const videoUrl = openBtn.getAttribute('data-video-url');
        videoPlayer.querySelector('source').setAttribute('src', videoUrl);
        videoPlayer.load();
        modal.classList.add('flex');
        modal.classList.remove('opacity-0', 'pointer-events-none');
        modal.classList.add('opacity-100');
      });
    }

    if (closeModalBtn) {
      closeModalBtn.addEventListener('click', function () {
        modal.classList.remove('flex');
        modal.classList.remove('opacity-100');
        modal.classList.add('opacity-0', 'pointer-events-none');
        videoPlayer.pause();
      });
    }
});

/** testimonial-comparison.liquid **/

document.addEventListener('DOMContentLoaded', () => {
  const track = document.querySelector('[data-slider-track]');
  const slides = document.querySelectorAll('[data-slide]');
  const navButtons = document.querySelectorAll('[data-slide-nav]');

  /*track.style.willChange = 'transform';*/

  // Optional autoplay 
  const sliderRoot = track.closest('[data-autoplay]') || track.closest('media-slider');
  const autoplay = sliderRoot?.dataset.autoplay === 'true';
  const speedSec = parseFloat(sliderRoot?.dataset.speed) || 8;
  let timer;

  let activeSlide = 0;

  function goToSlide(index) {
    if (index < 0 || index >= slides.length) return;
    activeSlide = index;
    track.style.transform = `translateX(-${activeSlide * 100}%)`;
    updateNav();
  }

  function updateNav() {
    navButtons.forEach((btn) => {
      const isActive = parseInt(btn.getAttribute('data-slide-nav')) === activeSlide;
      btn.classList.toggle('ring-2', isActive);
      btn.classList.toggle('ring-black', isActive);
      btn.classList.toggle('opacity-50', !isActive);
    });
  }

  function startAuto() {
    if (!autoplay) return;
    stopAuto();
    timer = setInterval(() => {
      goToSlide((activeSlide + 1) % slides.length);
    }, speedSec * 1000); // 🔸 slower interval
  }

  function stopAuto() {
    if (timer) clearInterval(timer);
    timer = null;
  }

  // Pause autoplay on user interaction (optional)
  const hoverZone = sliderRoot || track;
  hoverZone.addEventListener('mouseenter', stopAuto);
  hoverZone.addEventListener('mouseleave', startAuto);

  navButtons.forEach(btn => {
    const index = parseInt(btn.getAttribute('data-slide-nav'));
    btn.addEventListener('click', () => {
      goToSlide(index);
      // restart autoplay after manual nav (optional)
      startAuto();
    });
  });

  // init
  goToSlide(0);
  startAuto();

  // image-comparison-drag.js

});


/** ingredients-with-hover.liquid **/

function openModal3() {
  document.getElementById('ingredient-modal').classList.remove('hidden');
  document.getElementById('ingredient-modal').classList.add('flex');
}

function closeModal3() {
  document.getElementById('ingredient-modal').classList.add('hidden');
  document.getElementById('ingredient-modal').classList.remove('flex');
}

/** ingredients-circle.liquid **/

function openModal2() {
  const modal = document.getElementById('ingredient-modal');
  modal.classList.remove('opacity-0', 'pointer-events-none');
  modal.classList.add('opacity-100');
}

function closeModal2() {
  const modal = document.getElementById('ingredient-modal');
  modal.classList.remove('opacity-100');
  modal.classList.add('opacity-0', 'pointer-events-none');
}

/** ingredients-carousel.liquid **/

document.addEventListener('DOMContentLoaded', function () {
    const slides = document.querySelectorAll('.fade-slide');
    const navs = document.querySelectorAll('.slide-nav');

    function showSlide(index) {
      slides.forEach((slide, i) => {
        slide.classList.toggle('hidden', i !== index);
        slide.classList.toggle('opacity-0', i !== index);
        slide.classList.toggle('opacity-100', i === index);
      });

      navs.forEach((btn, i) => {
        btn.classList.toggle('opacity-100', i === index);
        btn.classList.toggle('opacity-50', i !== index);
      });
    }

    navs.forEach((btn, i) => {
      btn.addEventListener('click', () => showSlide(i));
    });

    showSlide(0);
});

document.addEventListener('DOMContentLoaded', function () {
  // --- PART A: On the source page (with #stockist-search-input + #stockist-search-btn)
  (function () {
    const input = document.getElementById('stockist-search-input');
    const link  = document.getElementById('stockist-search-btn');
    if (!input || !link) return;

    link.addEventListener('click', function (e) {
      const value = input.value.trim();
      if (!value) {
        e.preventDefault();
        alert('Please enter a city or ZIP code');
        return;
      }
      // Navigate with ?search=
      link.href = `/pages/find-a-professional?search=${encodeURIComponent(value)}`;
    });
  })();

  // --- PART B: On /pages/find-a-professional (auto-fill, click autocomplete, then search)
  (function () {
    if (window.location.pathname !== '/pages/find-a-professional') return;

    const params = new URLSearchParams(window.location.search);
    const q = params.get('search');
    if (!q) return;

    // Helper to wait for elements
    const waitFor = (sel, cb) => {
      const found = document.querySelector(sel);
      if (found) return cb(found);
      const mo = new MutationObserver(() => {
        const el = document.querySelector(sel);
        if (el) { mo.disconnect(); cb(el); }
      });
      mo.observe(document.documentElement, { childList: true, subtree: true });
    };

    waitFor('.stockist-search-field', (input) => {
      // Fill input
      input.value = q;
      input.dispatchEvent(new Event('input',  { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));

      // Simulate Enter once
      ['keydown', 'keypress', 'keyup'].forEach(type => {
        input.dispatchEvent(new KeyboardEvent(type, { key: 'Enter', bubbles: true }));
      });

      let tries = 0;
      const maxTries = 40; // ~10s
      const intervalMs = 250;

      const tryClick = () => {
        tries++;

        // Click first autocomplete suggestion if exists
        const suggestion = document.querySelector('.stockist-autocomplete');
        if (suggestion && !suggestion.dataset.autoClicked) {
          suggestion.dataset.autoClicked = '1';
          suggestion.click();
          return; // Wait for Stockist to process before trying search
        }

        // Click the search button
        const btn = document.querySelector('.stockist-feature-bg-color');
        if (btn && !btn.dataset.autoClicked) {
          if (!btn.disabled) {
            btn.dataset.autoClicked = '1';
            btn.click();
            clearInterval(clicker);
            return;
          }
        }

        if (tries >= maxTries) clearInterval(clicker);
      };

      const clicker = setInterval(tryClick, intervalMs);
      tryClick();
    });
  })();
});

/** update cart count **/

document.addEventListener("DOMContentLoaded", function () {
  const SELECTORS = [
    ".product-buy-buttons--primary form[action*='/cart/add']",
    "product-form form[action*='/cart/add']",
    "form[action*='/cart/add']",
    "#product-form",
    "product-form form"
  ];

  function findATCForm() {
    for (const s of SELECTORS) {
      const f = document.querySelector(s);
      if (f) return f;
    }
    const btn = document.querySelector(
      ".product-buy-buttons--primary [type='submit'], button[name='add'], [type='submit'][name='add']"
    );
    return btn ? btn.closest("form") : null;
  }

  // Try to read cart count from common DOM targets
  function getCartCountFromDom() {
    const el =
      document.querySelector("[data-cart-count]") ||
      document.querySelector(".cart-count-bubble, [aria-label*='cart'] .count, .header__cart-count") ||
      document.querySelector("#cart-count, .header-cart__count");
    if (!el) return null;
    const n = parseInt((el.getAttribute("data-cart-count") || el.textContent || "").replace(/\D+/g, ""), 10);
    return isNaN(n) ? null : n;
  }

  function openDrawer() {
    if (typeof window.openCartDrawer === "function") {
      window.openCartDrawer();
      return true;
    }
    // Fallback: try clicking a cart icon that opens the drawer
    const triggers = document.querySelectorAll(
      "[data-cart-toggle], .js-cart-toggle, .header__icon--cart, a[href='#cart'], button[aria-controls='cart-drawer']"
    );
    if (triggers.length) {
      triggers[0].click();
      return true;
    }
    return false;
  }

  // Watch for cart count increase; if it changes, open the drawer
  function watchCartCountOnce(prevCount, timeoutMs = 3000) {
    let done = false;
    const stop = () => { done = true; mo.disconnect(); clearTimeout(tid); };

    const mo = new MutationObserver(() => {
      if (done) return;
      const now = getCartCountFromDom();
      if (now != null && prevCount != null && now > prevCount) {
        openDrawer();
        stop();
      }
    });

    // Observe body for any text changes (broad but reliable)
    mo.observe(document.body, { childList: true, subtree: true, characterData: true });

    const tid = setTimeout(() => {
      if (!done) stop();
    }, timeoutMs);

    return stop;
  }

  function submitForm(form) {
    // Prefer native submit flow so theme handlers run
    if (form.requestSubmit) {
      const btn = form.querySelector("[type='submit']");
      form.requestSubmit(btn || undefined);
      return true;
    }
    const ok = form.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
    if (ok && typeof form.submit === "function") {
      form.submit();
      return true;
    }
    return false;
  }

  async function ajaxFallback(form) {
    const idInput = form?.querySelector("input[name='id'], select[name='id']");
    const qtyInput = form?.querySelector("input[name='quantity']");
    const id = idInput?.value;
    const quantity = Number(qtyInput?.value || 1) || 1;
    if (!id) return false;

    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id, quantity })
    });
    if (!res.ok) return false;

    // We control this path -> open immediately
    openDrawer();
    return true;
  }

  function whenEnabled(el, cb, timeout = 800) {
    if (!el) return cb();
    if (!el.disabled) return cb();
    const start = performance.now();
    (function tick() {
      if (!el.disabled) return cb();
      if (performance.now() - start > timeout) return cb();
      requestAnimationFrame(tick);
    })();
  }

  document.querySelectorAll(".s-atc").forEach(btn => {
    btn.addEventListener("click", async (e) => {
      e.preventDefault();

      const form = findATCForm();
      if (!form) {
        console.warn("[s-atc] No add-to-cart form found.");
        return;
      }

      const before = getCartCountFromDom();
      let stopWatching;

      const submitBtn = form.querySelector("[type='submit'], button[name='add']");
      whenEnabled(submitBtn, async () => {
        // Start watching for cart count increase (theme submit path)
        stopWatching = watchCartCountOnce(before);

        const fired = submitForm(form);
        if (fired) {
          // Give the theme a short moment; if it doesn't open, we already watch for count change
          setTimeout(() => {
            // If theme didn't update count (some stores don't show it), still open as a fallback UX
            openDrawer();
          }, 800);
          return;
        }

        // If submit couldn’t fire, try AJAX and open immediately on success
        const ok = await ajaxFallback(form);
        if (!ok) console.warn("[s-atc] Add to cart failed (submit + ajax).");
      });

      // Clean up watcher if user navigates
      window.addEventListener("beforeunload", () => stopWatching && stopWatching(), { once: true });
    });
  });
});

/** Carousel **/

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".simple-carousel").forEach((root) => {
    const wrapper = root.querySelector(".simple-carousel__wrapper");
    const track   = root.querySelector(".simple-carousel__track");
    const slides  = Array.from(root.querySelectorAll(".simple-carousel__slide"));
    const dots    = Array.from(root.querySelectorAll(".simple-carousel__dot"));
    if (!wrapper || slides.length === 0 || dots.length === 0) return;

    // Config
    const peekPct = Math.max(0, Math.min(50, Number(root.dataset.peek || 20)));
    root.style.setProperty("--peek", `${peekPct}vw`);

    // Cache slide positions (offsetLeft relative to track)
    let positions = [];
    const measure = () => { positions = slides.map(s => s.offsetLeft); };

    // Binary search nearest slide index for a given scrollLeft
    const indexFromScrollLeft = (x) => {
      let lo = 0, hi = positions.length - 1;
      while (lo < hi) {
        const mid = (lo + hi) >> 1;
        if (positions[mid] <= x) lo = mid + 1; else hi = mid;
      }
      const i = Math.max(0, Math.min(positions.length - 1, lo));
      return (i > 0 && Math.abs(positions[i] - x) > Math.abs(positions[i - 1] - x)) ? i - 1 : i;
    };

    // Active dot
    let active = -1;
    const setActive = (i) => {
      if (i === active) return;
      active = i;
      dots.forEach((d, idx) => d.classList.toggle("active", idx === i));
    };

    // ---- Smooth programmatic scroll WITHOUT snap fighting ----
    let animId = 0;            // non-zero when animating
    const setSnapEnabled = (on) => {
      wrapper.style.scrollSnapType = on ? "x mandatory" : "none";
    };

    const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

    const animateTo = (targetLeft, duration = 380) => {
      animId++;
      const thisAnim = animId;
      const start = wrapper.scrollLeft;
      const delta = targetLeft - start;
      if (Math.abs(delta) < 1) { wrapper.scrollLeft = targetLeft; return; }

      setSnapEnabled(false); // avoid fight with snap while animating
      const t0 = performance.now();

      const step = (now) => {
        if (thisAnim !== animId) return; // cancelled
        const t = Math.min(1, (now - t0) / duration);
        const k = easeOutCubic(t);
        wrapper.scrollLeft = start + delta * k;
        if (t < 1) requestAnimationFrame(step);
        else {
          // finalize on the exact position, then re-enable snap
          wrapper.scrollLeft = targetLeft;
          setSnapEnabled(true);
          // snap to the nearest (in case of rounding)
          const idx = indexFromScrollLeft(wrapper.scrollLeft);
          // align exactly to slide start for pixel-perfect result
          wrapper.scrollLeft = positions[idx];
        }
      };
      requestAnimationFrame(step);
    };

    // Scroll to slide index (align to wrapper's scroll-padding-left automatically)
    const scrollToIndex = (i) => {
      const target = positions[i] ?? 0;
      animateTo(target);
    };

    // Dots -> animate to slide
    dots.forEach((dot, i) => dot.addEventListener("click", () => scrollToIndex(i)));

    // rAF-throttled scroll listener for dot sync (cheap; no DOM reads)
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        setActive(indexFromScrollLeft(wrapper.scrollLeft));
        ticking = false;
      });
    };
    wrapper.addEventListener("scroll", onScroll, { passive: true });

    // Re-measure when layout changes
    const ro = new ResizeObserver(() => {
      const prevIndex = indexFromScrollLeft(wrapper.scrollLeft);
      measure();
      // keep user on the same slide anchor after resize
      animateTo(positions[prevIndex] || 0, 0);
      setActive(prevIndex);
    });
    ro.observe(track);

    // Re-measure after images load
    const imgs = root.querySelectorAll("img");
    let wait = imgs.length;
    if (wait) {
      imgs.forEach(img => {
        if (img.complete) { if (--wait === 0) measure(); }
        else img.addEventListener("load", () => { if (--wait === 0) measure(); }, { once: true });
      });
    }

    // Init
    measure();
    setActive(indexFromScrollLeft(wrapper.scrollLeft));

    // Optional: snap gently when user stops dragging (works even without 'scrollend')
    let pointerDown = false;
    wrapper.addEventListener("pointerdown", () => { pointerDown = true; }, { passive: true });
    ["pointerup","pointercancel","pointerleave"].forEach(evt => {
      wrapper.addEventListener(evt, () => {
        if (!pointerDown) return;
        pointerDown = false;
        // allow momentum to finish before nudging to nearest start
        setTimeout(() => {
          const idx = indexFromScrollLeft(wrapper.scrollLeft);
          animateTo(positions[idx] || 0, 220);
        }, 40);
      }, { passive: true });
    });
  });
});


/*** ADD STOCKIST BADGE CLASSES **/

document.addEventListener("DOMContentLoaded", () => {
  const LIST_SEL   = ".stockist-result-list";
  const FILTER_SEL = ".stockist-result-filter";
  const PREFIX     = "badge-";       // class prefix
  const POLL_MS    = 300;            // how often to re-run
  const MAX_MS     = 20000;          // stop after 20s (adjust)

  function slugify(t) {
    return (t || "").trim().toLowerCase();
  }

  function tag(el) {
    const txt  = slugify(el.textContent);
    if (!txt) return;
    // remove any old badge-* classes
    el.className = el.className.replace(/\bbadge-\S+/g, "").trim();
    // add new
    el.classList.add(PREFIX + txt);
  }

  function run() {
    const list = document.querySelector(LIST_SEL);
    if (!list) return false;
    list.querySelectorAll(FILTER_SEL).forEach(tag);
    return true;
  }

  // initial
  run();

  // poll for updates
  const deadline = Date.now() + MAX_MS;
  const iv = setInterval(() => {
    run();
    if (Date.now() > deadline) clearInterval(iv);
  }, POLL_MS);

  // optional: quick bursts right after load to catch immediate swaps
  setTimeout(run, 150);
  setTimeout(run, 600);
  setTimeout(run, 1200);
});

function openVideoModal(sectionId, btnEl) {
  const modal = document.getElementById(`videoModal-${sectionId}`);
  const video = document.getElementById(`videoPlayer-${sectionId}`);
  if (!modal || !video) return;

  // If the opener button provides a URL, set it
  const newSrc = btnEl?.dataset?.videoUrl;
  if (newSrc) {
    let sourceEl = video.querySelector('source');
    if (!sourceEl) {
      sourceEl = document.createElement('source');
      sourceEl.type = 'video/mp4';
      video.appendChild(sourceEl);
    }
    if (sourceEl.src !== newSrc) {
      sourceEl.src = newSrc;
      try { video.load(); } catch (e) {}
    }
  }

  modal.classList.remove('hidden');
  modal.classList.add('flex');
  video.play?.().catch(() => {});
}

function closeVideoModal(sectionId) {
  const modal = document.getElementById(`videoModal-${sectionId}`);
  const video = document.getElementById(`videoPlayer-${sectionId}`);
  if (!modal || !video) return;

  try { video.pause(); video.currentTime = 0; } catch (e) {}
  modal.classList.add('hidden');
  modal.classList.remove('flex');
}

// Wire close buttons & backdrops for all section modals
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[id^="closeModal-"]').forEach(btn => {
    const sectionId = btn.id.replace('closeModal-','');
    btn.addEventListener('click', () => closeVideoModal(sectionId));
  });
  document.querySelectorAll('[id^="videoModal-"]').forEach(modal => {
    const sectionId = modal.id.replace('videoModal-','');
    modal.addEventListener('click', (e) => {
      if (e.target === modal) closeVideoModal(sectionId);
    });
  });
});


/** nav hover **/


/** video volume button on PDP **/

(function () {
  const DEFAULT_UNMUTE_VOLUME = 0.5;

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function canProgrammaticallySetVolume() {
    try {
      const v = document.createElement('video');
      const orig = v.volume;
      v.volume = 0.5;
      return v.volume === 0.5 && orig !== 0.5;
    } catch (e) {
      return false;
    }
  }
  const canSetVolume = canProgrammaticallySetVolume();

  const isVisible = el => !!(el && el.getClientRects().length && (el.offsetWidth || el.offsetHeight));
  const uniq = arr => arr.filter((el, i) => arr.indexOf(el) === i);

  function getMediaEls(scope) {
    const plyr = Array.from(scope.querySelectorAll('.plyr video, .plyr audio'));
    const plain = Array.from(scope.querySelectorAll('video, audio'));
    const list = plyr.length ? plyr : plain;
    return uniq(list).filter(isVisible);
  }

  function setVolumes(scope, vol) {
    let changed = false;
    const sliders = Array.from(scope.querySelectorAll('.plyr__volume input[type="range"]'));
    if (sliders.length) {
      sliders.forEach((inp) => {
        try {
          inp.value = String(vol);
          inp.dispatchEvent(new Event('input', { bubbles: true }));
          inp.dispatchEvent(new Event('change', { bubbles: true }));
          changed = true;
        } catch (_) {}
      });
    } else {
      getMediaEls(scope).forEach((m) => {
        try {
          m.muted = false;
          m.volume = vol;
          changed = true;
        } catch (_) {}
      });
    }
    return changed;
  }

  function setMuted(scope, isMuted) {
    let changed = false;
    getMediaEls(scope).forEach((m) => {
      try {
        m.muted = isMuted;
        changed = true;
      } catch (_) {}
    });
    return changed;
  }

  function initOne(soundControls) {
    if (!soundControls || soundControls.__inited) return;
    soundControls.__inited = true;

    const soundOff = soundControls.querySelector('#soundOff, .soundOff, [data-sound="off"]');
    const soundOn  = soundControls.querySelector('#soundOn,  .soundOn,  [data-sound="on"]');
    if (!soundOff || !soundOn) {
      console.warn('[SoundControls] Missing #soundOff/#soundOn inside one .sound_controls');
      return;
    }

    const scope =
      soundControls.closest('[data-sound-scope]') ||
      soundControls.closest('.media-slider, .slider, .plyr, .shopify-section, section') ||
      soundControls.parentElement ||
      soundControls;

    // Show control immediately (avoid flicker)
    soundControls.style.display = 'inline-block';
    // Mobile tap hygiene
    soundControls.style.touchAction = 'manipulation';
    soundControls.style.webkitTapHighlightColor = 'transparent';
    soundControls.style.cursor = soundControls.style.cursor || 'pointer';

    // Initial UI: muted, show "sound off"
    soundOff.style.display = 'inline-block';
    soundOn.style.display  = 'none';

    if (canSetVolume) setVolumes(scope, 0);
    else setMuted(scope, true);

    function syncIcons(unmuted) {
      if (unmuted) {
        soundOff.style.display = 'none';
        soundOn.style.display  = 'inline-block';
      } else {
        soundOff.style.display = 'inline-block';
        soundOn.style.display  = 'none';
      }
    }

    function toggle() {
      if (canSetVolume) {
        const anyUnmuted =
          Array.from(scope.querySelectorAll('.plyr__volume input[type="range"]'))
            .some(inp => Number(inp.value || 0) > 0) ||
          getMediaEls(scope).some(m => !m.muted && m.volume > 0);

        if (anyUnmuted) {
          setVolumes(scope, 0);
          syncIcons(false);
        } else {
          setVolumes(scope, DEFAULT_UNMUTE_VOLUME);
          getMediaEls(scope).forEach(m => m.muted = false);
          syncIcons(true);
        }
      } else {
        const anyUnmuted = getMediaEls(scope).some(m => !m.muted);
        setMuted(scope, anyUnmuted);
        syncIcons(!anyUnmuted);
      }
    }

    // ---- Mobile-robust tap binding ----
    let tapLock = false;
    const UNLOCK_MS = 250;

    const handler = (e) => {
      // Stop carousels/parents from stealing the gesture
      if (e) {
        if (typeof e.preventDefault === 'function') e.preventDefault();
        if (typeof e.stopPropagation === 'function') e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      }
      if (tapLock) return;
      tapLock = true;
      toggle();
      setTimeout(() => (tapLock = false), UNLOCK_MS);
    };

    // Prefer pointer events; fall back to click
    soundControls.addEventListener('pointerdown', handler, { passive: false });
    soundControls.addEventListener('click', handler, { passive: false });

    // Keep late-added media IN THIS SCOPE in sync
    const mo = new MutationObserver(() => {
      const on = soundOn.style.display === 'inline-block';
      if (canSetVolume) setVolumes(scope, on ? DEFAULT_UNMUTE_VOLUME : 0);
      else setMuted(scope, !on);
    });
    mo.observe(scope, { childList: true, subtree: true });
  }

  onReady(function () {
    document.querySelectorAll('.sound_controls').forEach(initOne);

    const bootObserver = new MutationObserver(() => {
      document.querySelectorAll('.sound_controls').forEach(initOne);
    });
    bootObserver.observe(document.documentElement, { childList: true, subtree: true });
  });
})();

/** collection nav position **/

document.addEventListener('DOMContentLoaded', () => {
  const menu = document.querySelector('.blog--filter--menu');
  const active = menu?.querySelector('.blog--filter--menu-item[data-selected="true"]');
  if (!menu || !active) return;

  // If the active item is the first, don't scroll at all.
  const first = menu.querySelector('.blog--filter--menu-item');
  if (active === first) {
    menu.scrollLeft = 0;
    return;
  }

  // Scroll so the active item’s left edge sits just after the container’s left padding
  const leftPad = parseFloat(getComputedStyle(menu).paddingLeft) || 0;
  const target =
    active.getBoundingClientRect().left
    - menu.getBoundingClientRect().left
    + menu.scrollLeft
    - leftPad;

  // Temporarily disable scroll snapping to avoid snapping to the second item
  const prevSnap = menu.style.scrollSnapType;
  menu.style.scrollSnapType = 'none';
  menu.scrollLeft = Math.max(0, target);
  requestAnimationFrame(() => {
    menu.style.scrollSnapType = prevSnap || '';
  });
});

/** empty cart page **/

document.addEventListener("DOMContentLoaded", function () {
  var cartPages = document.querySelectorAll("#cartPage");

  // If no cart pages exist, do nothing
  if (!cartPages.length) return;

  function toggleCartPages() {
    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var empty = cart.item_count === 0;

        cartPages.forEach(function (cartPage) {
          var cartForm   = cartPage.querySelector(".cart--form");
          var emptyState = cartPage.querySelector(".cart--empty2");

          if (empty) {
            if (cartForm)   cartForm.classList.add("hidden");
            if (emptyState) emptyState.classList.remove("hidden");
            cartPage.classList.add("empty");
          } else {
            if (cartForm)   cartForm.classList.remove("hidden");
            if (emptyState) emptyState.classList.add("hidden");
            cartPage.classList.remove("empty");
          }
        });
      })
      .catch(function (err) {
        console.error(err);
      });
  }

  // Run on load
  toggleCartPages();

  // Run whenever cart updates (AJAX changes, add/remove, etc.)
  document.addEventListener("cart:refresh", toggleCartPages);
});

/***/
















































